import { Controller } from "@hotwired/stimulus";

// The bearer credential lives in the fragment of the mailed URL. A fragment never reaches the
// server, proxy or Referer header: the browser gives it only to this controller. Remove it from
// history before doing anything else, then submit it once in a filtered POST field. From there
// Rails keeps it in the encrypted cookie session and every visible URL is fixed.
export default class extends Controller {
  static targets = ["form", "token", "invalid"];

  connect() {
    const fragment = window.location.hash.slice(1);
    const token = new URLSearchParams(fragment).get("token");

    window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}`);

    if (!token) {
      this.invalidTarget.classList.remove("hidden");
      return;
    }

    this.tokenTarget.value = token;
    this.formTarget.requestSubmit();
  }
}
